import React from "react";

export default function Chatting() {
  return (
    <div>
      <div className="balanceBox">
        <div className="balanceBoxInner bg-light">
          <h2 className="balanceBoxTitle text-center text-dark">Chatting</h2>
        </div>
      </div>
    </div>
  );
}
